import { useCallback, useContext } from 'react';

import PropTypes from 'prop-types';

import { AuthContext } from '../../../../../actions/auth-context';
import {
  startSpreadInspectionTheOrder,
  approveSpreadEditTheOrder,
} from '../../../../../actions/order.service';
import ActionModal from './ActionModal';

const SpreadInspectionModal = ({ order, setOrder }) => {
  const { setLoading } = useContext(AuthContext);

  const uploadOrder = useCallback((response) => {
    if (!response.error) {
      response.delivery_date = new Date(response.delivery_date);

      if (response.payment_first_date) {
        response.payment_first_date = new Date(
          response.payment_first_date.replace(/-/g, ',')
        );
      }

      setOrder(response);
    }
  }, []);

  const startSpreadInspectionOrder = useCallback(async (data) => {
    setLoading(true);

    const response = await startSpreadInspectionTheOrder(data.order_id, data);

    uploadOrder(response);

    setLoading(false);
  }, []);

  const approveSpreadEditOrder = useCallback(async (data) => {
    setLoading(true);

    const response = await approveSpreadEditTheOrder(data.order_id, data);

    uploadOrder(response);

    setLoading(false);
  }, []);

  return (
    <>
      <ActionModal
        modal_id="modal-start-spread-inspection-order"
        title="iniciar inspeção de lâminas do pedido?"
        action={startSpreadInspectionOrder}
        order={order}
      />

      <ActionModal
        modal_id="modal-approve-spread-edit-order"
        title="aprovar edição de lâminas do pedido?"
        action={approveSpreadEditOrder}
        order={order}
      />
    </>
  );
};

SpreadInspectionModal.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.string,
    order_status: PropTypes.string,
  }).isRequired,
  setOrder: PropTypes.func.isRequired,
};

export default SpreadInspectionModal;
